import "../Privacy/Privacy.scss";

const Terms = () => {
  return (
    <div className="privacy">
      <div className="privacy-line">
        <h1>Syarat & Ketentuan</h1>
        <p className="last-updated">Terakhir diperbarui: Juli 2026</p>

        <h2>Informasi Properti</h2>
        <p>
          Semua informasi mengenai spesifikasi, harga, dan promo yang ditampilkan di situs ini bersifat indikatif dan dapat berubah sewaktu-waktu tanpa pemberitahuan sebelumnya.
        </p>

        <h2>Harga & Promo</h2>
        <p>
          Harga dan cicilan yang tercantum merupakan estimasi dan dapat berbeda dengan harga resmi dari pengembang. Tanda (*) menunjukkan syarat dan ketentuan berlaku.
        </p>

        <h2>Konsultasi & Pembelian</h2>
        <p>
          Kami menyediakan layanan informasi dan konsultasi properti. Untuk pembelian resmi, hubungi pengembang atau agen resmi Summarecon.
        </p>

        <h2>Kebebasan Informasi</h2>
        <p>
          Situs ini merupakan portal informasi independen. Hubungi kami untuk informasi lebih lanjut.
        </p>
      </div>
    </div>
  );
};

export default Terms;
